
export * from '../../frontend-js-codemirror-web/__liferay__/index.js';
